import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ItemsListRowItemBase } from '@fi-app/components/items-list/list-row/list-row-item/list-row-item-base';
import { IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { isFunction } from '@fi-shared/utils';

@Component({
    selector: 'fi-user-list-profile-icon-column',
    template: `<fi-profile-icon [profileData]="userProfile"></fi-profile-icon>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-list-profile-icon-column' },
    standalone: false,
})
export class UserListProfileIconColumnComponent extends ItemsListRowItemBase implements OnInit {
    userProfile: IUserProfile;

    ngOnInit(): void {
        this.userProfile = isFunction(this.head.DisplayPropertyName)
            ? this.head.DisplayPropertyName(this.data, this.head.PropertyName, this.parentData)
            : this.data;
        super.ngOnInit();
    }
}
